"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Quote = function Quote(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 24 24",
    height: "24",
    width: "24"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.559,3.932c-2.729-0.039-4.973,2.142-5.012,4.871s2.142,4.973,4.871,5.012c0.047,0.001,0.094,0.001,0.141,0 c0.376-0.001,0.75-0.049,1.115-0.141c0.134-0.033,0.269,0.049,0.302,0.183c0.015,0.063,0.006,0.129-0.026,0.185 c-1.186,2.143-3.429,3.488-5.878,3.523c-0.69,0-1.25,0.56-1.25,1.25s0.56,1.25,1.25,1.25c5.347-0.154,9.562-4.603,9.428-9.95V8.873 C23.497,6.146,21.286,3.935,18.559,3.932z M6.236,3.932c-2.729,0.039-4.91,2.283-4.871,5.012c0.038,2.674,2.197,4.833,4.871,4.871 c0.376-0.001,0.75-0.049,1.115-0.141c0.134-0.034,0.27,0.048,0.303,0.182c0.016,0.063,0.006,0.13-0.026,0.186 c-1.186,2.143-3.429,3.488-5.878,3.523c-0.69,0-1.25,0.56-1.25,1.25s0.56,1.25,1.25,1.25c5.347-0.154,9.562-4.603,9.428-9.95V8.873 C11.175,6.145,8.964,3.935,6.236,3.932z",
    stroke: "none",
    fill: fill,
    strokeWidth: "0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
Quote.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Quote.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Quote;